module.exports = __webpack_public_path__ + "img/casino-bota.3a208391.jpg";